<script>
  import { onMount } from "svelte";
  import { result } from "../store.js";

  export let item = {
    type: "text-area",
    min: 1,
    max: 100,
    required: false,
    title: "",
    description: "",
    placeholder: "",
  };
  export let index = 0;

  onMount(() => {
    $result[index] = "";
  });
</script>

<textarea
  rows="5"
  required={item.required}
  placeholder={item.placeholder || ""}
  bind:value={$result[index]}
/>

<style>
  textarea {
    width: 100%;
  }
</style>
